import { FC, useState } from "react";
import { Grid, ButtonGroup, IconButton, Typography, Autocomplete, Button, TextField, Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import { useDepartmentStore } from "../../hooks/useDepartmentStore";
import { useOwnerStore } from "../../hooks/useOwnerStore";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { useReportStore } from "../../hooks/useReportStore";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { FilterComponent } from "./components/FilterComponent";
import { moneyFormat } from "../../toolbox/helpers/money-helpers";
import { NotData } from "./components/NotData";
import { ReportAPI } from "../../apis/ReportAPI";

const columns = [
    { type: 'text', field: 'name_concept', label: 'CONCEPTO DE PAGO', align: 'center' },
    { type: 'text', field: 'name_owner', label: 'PROPIETARIO', align: 'center' },
    {
        type: 'text', field: 'total_department', label: 'TOTAL DEPARTAMENTO', align: 'center',
        format: (row) => moneyFormat(row.total_department, '$')
    },
    {
        type: 'text', field: 'total_owner', label: 'TOTAL PROPIETARIO', align: 'center',
        format: (row) => moneyFormat(row.total_owner, '$')
    },
]

export const ReportAdminRendition: FC = () => {

    const { status: statusApiDepartment, departments, getDepartments } = useDepartmentStore()
    const { status: statusOwnerApi, owners, getOwners } = useOwnerStore()
    const { getReportRendition, status, dataReportRendition, filter, department, owner, year, month } = useReportStore();
    const [params, setParams] = useState<any>();

    const downloadExcel = async () => {
        const response  = await ReportAPI.getReportRenditionExcel(params);

        if(response.status){
            const btn_excel = document.createElement('a');
            btn_excel.href = `${response.link}`
            document.body.appendChild(btn_excel);
            btn_excel.click();
            document.body.removeChild(btn_excel)
        }

    }
    const onListRendition = () => {
        let dataParams = {}
        switch (filter) {
            case '01':
                dataParams = {
                    "month": month.substring(month.length - 2),
                    "year": month.substring(0, 4),
                    "iddepartment": department.id,
                    "idcompany": 1
                }
                getReportRendition(dataParams)
                setParams(dataParams)
                break;
            case '02':
                dataParams = {
                    "year": year?.name,
                    "iddepartment": department.id,
                    "idcompany": 1
                }
                getReportRendition(dataParams)
                setParams(dataParams)
                break;
            case '03':
                dataParams = {
                    "month": month.substring(month.length - 2),
                    "year": month.substring(0, 4),
                    "idowner": owner.id,
                    "idcompany": 1
                }
                getReportRendition(dataParams)
                setParams(dataParams)
                break;
            case '04':
                dataParams = {
                    "year": year?.name,
                    "idowner": owner.id,
                    "idcompany": 1
                }
                getReportRendition(dataParams)
                setParams(dataParams)
                break;
            case '05':
                dataParams = {
                    "month": month.substring(month.length - 2),
                    "year": month.substring(0, 4),
                    "idowner": owner.id,
                    "iddepartment": department.id,
                    "idcompany": 1
                }
                getReportRendition(dataParams)
                setParams(dataParams)
                break;
            case '06':
                dataParams = {
                    "year": year?.name,
                    "idowner": owner.id,
                    "iddepartment": department.id,
                    "idcompany": 1
                }
                getReportRendition(dataParams)
                setParams(dataParams)
                break;
            default:
                break;
        }
    }

    return (
        <>
            {statusApiDepartment === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            {statusOwnerApi === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}

            <Grid container>
                <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '10px' }}>
                    <Typography variant='h6' component='h1' gutterBottom color='#808080' className="tittle" sx={{ mt: 1, ml: 1, fontWeight: 600 }}>
                        {('Reporte de Rendiciones').toUpperCase()}
                    </Typography>
                </Grid>
                <FilterComponent submit={onListRendition} />
                {
                    dataReportRendition?.data_department?.length > 0 ?
                        (dataReportRendition.data_department).map((departmentItem) => {
                            return (
                                <>
                                    <Grid item container sx={{ padding: 2 }}>
                                        <Button onClick={() => { downloadExcel() }}
                                            sx={{
                                                height: '35px',
                                                backgroundColor: '#212D39',
                                                color: '#fff',
                                                textTransform: 'none',
                                                padding: '4px 10px',
                                                "&:hover": { backgroundColor: "#212D39" }, fontSize: "12px"
                                            }}>
                                            Descargar Excel</Button>
                                    </Grid>
                                    <Grid item container sx={{ padding: 2 }} key={departmentItem.name_department}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Departamento: {departmentItem.name_department}</Typography>
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <Typography variant="h6">Total: {moneyFormat(departmentItem.total, '$')}</Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            {departmentItem.data_category.map((dataCategory) => (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6">{dataCategory.name} : {moneyFormat(dataCategory.total, '$')} </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <CustomTable title={''} columns={columns} rows={dataCategory.data_item || []} onRowClick={() => { }} />
                                                    </Grid>
                                                </>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </>

                            );
                        })
                        :
                        <NotData />
                }
            </Grid>
        </>
    )
}